/* eslint-disable no-console */
import { useState, useEffect } from "react";
import { CarteleriaList, Header } from "../../components";
import { useAuthContext } from "../../context/auth";
import { useCurrency } from "../../utils";
import { client } from "../../utils/supabase";
import "./stylesCarteleriaPage.scss";

const CarteleriaPage = () => {
  const [showFormModal, setShowFormModal] = useState(false);
  const [negocios, setNegocios] = useState([]);
  const [loadingSummary, setLoadingSummary] = useState(true);

  const { pais } = useAuthContext();
  const normalizedPais = pais ? pais.charAt(0).toUpperCase() + pais.slice(1).toLowerCase() : "";
  const { loadingRates, convert, formatAmount } = useCurrency();
  const monedaLocal = normalizedPais === "Chile" ? "CLP" : "PEN";

  useEffect(() => {
    if (!normalizedPais) return;
    const fetchSummary = async () => {
      setLoadingSummary(true);
      try {
        const { data, error } = await client
          .from("negocios_carteleria")
          .select("*")
          .eq("pais", normalizedPais)
          .eq("eliminada", false);
        if (error) throw error;
        setNegocios(data || []);
      } catch (err) {
        console.error("Error fetching summary:", err);
      } finally {
        setLoadingSummary(false);
      }
    };
    fetchSummary();
  }, [normalizedPais]);

  // Cálculos de resumen
  const activos = negocios.filter((n) => (n.estado || "").toLowerCase() === "activo");
  const pipeline = negocios.filter((n) => ["100%", "90%", "75%", "50%"].includes((n.estado || "").toLowerCase()));
  const activosOPEX = activos.filter((n) => n.incluye_hardware && n.modalidad === "OPEX").length;
  const activosCAPEX = activos.filter((n) => n.incluye_hardware && n.modalidad === "CAPEX").length;
  const totalPantallas = activos.reduce((sum, n) => sum + (parseInt(n.cantidad_pantallas, 10) || 1), 0);

  let facturacionMensual = 0;
  if (!loadingRates) {
    activos.forEach((n) => {
      const pantallas = parseInt(n.cantidad_pantallas, 10) || 1;
      const gestion = parseFloat(n.fee_gestion_unitario || 0);
      const contenidos = n.incluye_contenidos ? parseFloat(n.fee_contenidos_unitario || 0) : 0;
      const opex = n.incluye_hardware && n.modalidad === "OPEX" ? parseFloat(n.cuota_hardware_opex || 0) : 0;
      // Cada componente puede estar en moneda distinta (gestión UF, contenidos CLP, opex USD/PEN).
      // Convertir cada uno a moneda local antes de sumar.
      const toLocal = (monto, moneda) => {
        if (!monto) return 0;
        const origen = moneda || monedaLocal;
        return origen !== monedaLocal ? convert(monto * pantallas, origen, monedaLocal) : monto * pantallas;
      };
      facturacionMensual +=
        toLocal(gestion, n.moneda_gestion) +
        toLocal(contenidos, n.moneda_contenidos || n.moneda_gestion) +
        toLocal(opex, n.moneda_hardware);
    });
  }

  const labelStyle = { minWidth: "160px" };
  const sep = <span style={{ margin: "0 0.4rem", color: "#999" }}>|</span>;

  const summaryContent =
    loadingSummary || loadingRates ? null : (
      <div className="d-flex align-items-start" style={{ gap: ".69rem", fontSize: "16.5px" }}>
        <div className="text-start" style={labelStyle}>
          <div>
            <strong>Negocios</strong>
          </div>
          <div>
            <strong>Fact. Mensual Est.</strong>
          </div>
        </div>
        <div className="text-start" style={{ fontSize: "16.5px" }}>
          <div>
            {sep} Activos: <strong>{activos.length}</strong>
            {sep} Pipeline: <strong>{pipeline.length}</strong>
            {sep} Pantallas: <strong>{totalPantallas}</strong>
          </div>
          <div>
            {sep} {formatAmount(facturacionMensual, monedaLocal)}
            {sep} OPEX: <strong>{activosOPEX}</strong>
            {sep} CAPEX: <strong>{activosCAPEX}</strong>
          </div>
        </div>
      </div>
    );

  return (
    <div className="carteleria-page">
      <Header leftContent={summaryContent}>
        <button className="btn btn-primary" onClick={() => setShowFormModal(true)}>
          Nuevo Proyecto
        </button>
      </Header>
      <div className="carteleria-list-full">
        <CarteleriaList showFormModal={showFormModal} setShowFormModal={setShowFormModal} />
      </div>
    </div>
  );
};

export default CarteleriaPage;
